<div *ngIf="(isImpersonating$ | async) !== true" class="prs-impersonation-picker" data-testing-id="csr-impersonation-picker">
  <button
    type="button"
    class="prs-header-action-stack prs-impersonation-picker__button"
    data-testing-id="csr-impersonation-open"
    [attr.aria-label]="'impersonation.view_as.aria' | translate"
    [disabled]="busy"
    (click)="openPicker()"
  >
    <i class="bi bi-headset prs-header-account-icon prs-impersonation-picker__icon" aria-hidden="true"></i>
    <span class="prs-header-action-strong">{{ 'impersonation.view_as.label' | translate }}</span>
  </button>
</div>
